<template>
    <div class="desc-container" v-if="descThirdLine">
        <div class="caret" :class="leftClass"></div>
        <div class="desc-third-line">{{descThirdLine}}</div>
    </div>
</template>
<script>
export default {
  name: 'AwardDesc',
  props: ['descThirdLine', 'getTaskListData'],
  computed: {
    leftClass () {
      // 1单的时候距离左边的距离
      // 2单的时候
      if (this.isOneTask) return 'caret1'
      if (this.isTwoTask) return 'caret2'
      // 多单的
      return 'caret-more'
    },
    isTwoTask () {
      return this.getTaskListData.length == 2 // eslint-disable-line
    },
    isOneTask () {
      return this.getTaskListData.length == 1 // eslint-disable-line
    }
  }
}
</script>
<style lang="stylus" scoped>
.desc-container 
    position relative
.desc-third-line
    font-family 'Aspira Light'
    font-size 28px
    color #000000
    line-height 36px
    font-weight 200
    padding 40px 32px
    background #F8F8F8
.caret 
    position absolute
    top -12px
    width 50px
    height 50px
    border-radius 8px
    background #F8F8F8
    z-index 1
    transform rotate(45deg)
.caret1
    left 50px
.caret2
    left 500px
.caret-more
    left 340px
</style>